var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.closeSelect,
          expression: "closeSelect",
        },
      ],
      staticClass: "bb-select",
      class: _vm.selectOpenedClass,
    },
    [
      _vm._t(
        "toggle",
        function () {
          return [
            _c(
              "div",
              {
                staticClass: "bb-select-toggle",
                on: { click: _vm.toggleSelect },
              },
              [
                _c("span", {
                  class: _vm.toggleSelectClass,
                  domProps: {
                    textContent: _vm._s(
                      _vm.selected
                        ? _vm.selected[_vm.selectedTextKey]
                        : _vm.placeholderHidden
                        ? ""
                        : _vm.placeholderText
                    ),
                  },
                }),
                _c("i", {
                  staticClass: "text-main",
                  class: _vm.selectArrowClass,
                }),
              ]
            ),
          ]
        },
        {
          toggleSelect: _vm.toggleSelect,
          removeSelected: _vm.removeSelected,
          isOpen: _vm.isOpen,
        }
      ),
      _vm.search && _vm.isOpen
        ? _c("div", { staticClass: "bb-select-search" }, [
            _c("div", { staticClass: "bb-select-search-input" }, [
              _c("i", { staticClass: "fas fa-search" }),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.searchTerm,
                    expression: "searchTerm",
                  },
                ],
                ref: "bbSelectSearchInput",
                staticClass: "bb-input",
                attrs: { type: "text", placeholder: _vm.searchPlaceholderText },
                domProps: { value: _vm.searchTerm },
                on: {
                  input: function ($event) {
                    if ($event.target.composing) return
                    _vm.searchTerm = $event.target.value
                  },
                },
              }),
              _c("i", {
                staticClass: "fas fa-times-circle",
                on: { click: _vm.closeSelect },
              }),
            ]),
          ])
        : _vm._e(),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isOpen,
              expression: "isOpen",
            },
          ],
          class: _vm.optionsClass,
          on: {
            wheel: function ($event) {
              $event.stopPropagation()
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "bb-select-options-container" },
            [
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.displayOptions.length === 0,
                      expression: "displayOptions.length === 0",
                    },
                  ],
                  staticClass: "no-options",
                },
                [_vm._v(" " + _vm._s(_vm.noOptionsDescription) + " ")]
              ),
              _c(
                "perfect-scrollbar",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.displayOptions.length > 0,
                      expression: "displayOptions.length > 0",
                    },
                  ],
                  ref: "selectScrollbar",
                  staticClass: "scroll scroll-push",
                  style: _vm.scrollbarHeight,
                  attrs: { options: _vm.scrollbarOptions },
                },
                _vm._l(_vm.displayOptions, function (option, key) {
                  return _c("div", { key: key }, [
                    option.options
                      ? _c(
                          "div",
                          [
                            _c(
                              "div",
                              { staticClass: "bb-select-option-group-title" },
                              [_vm._v(" " + _vm._s(option.text) + " ")]
                            ),
                            _vm._l(option.options, function (option) {
                              return _c(
                                "div",
                                {
                                  key: option.value,
                                  staticClass: "bb-select-option-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.optionSelected(option)
                                    },
                                  },
                                },
                                [
                                  _vm._t(
                                    "optionGroupItem",
                                    function () {
                                      return [
                                        _vm._v(" " + _vm._s(option.text) + " "),
                                      ]
                                    },
                                    { option: option }
                                  ),
                                ],
                                2
                              )
                            }),
                          ],
                          2
                        )
                      : _c("div", [
                          _c(
                            "div",
                            {
                              staticClass: "bb-select-option-item",
                              on: {
                                click: function ($event) {
                                  return _vm.optionSelected(option)
                                },
                              },
                            },
                            [
                              _vm._t(
                                "optionItem",
                                function () {
                                  return [
                                    _vm._v(" " + _vm._s(option.text) + " "),
                                  ]
                                },
                                { option: option }
                              ),
                            ],
                            2
                          ),
                        ]),
                  ])
                }),
                0
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: this.$slots["optionsFooter"],
                      expression: "this.$slots['optionsFooter']",
                    },
                  ],
                  ref: "optionsFooter",
                  staticClass: "bb-select-footer-item",
                },
                [_vm._t("optionsFooter")],
                2
              ),
            ],
            1
          ),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }